import About01 from '../assets/about-01.png';
import About02 from '../assets/about-02.png';
import About03 from '../assets/about-03.png';
import About04 from '../assets/about-04.png';
import { Layout } from '../components/page-layout';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
`;
const SectionRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 2rem;
  }
`;
const SectionCol = styled.div`
  padding: 1rem 0;
  text-align: left;
  @media (min-width: 768px) {
    text-align: left;
  }
`;
const SectionImg = styled.img`
  width: 100%;
  height: auto;
  min-width: 335px;
  max-width: 580px;
  object-fit: contain;
  @media (min-width: 768px) {
    width: 580px;
    height: 258px;
  }
`;
const Title = styled.h3`
  font-size: 1.875rem;
  font-weight: bold;
`;
const SubTitle = styled.h3`
  color: #2E2E2E;
  font-size: 16px;
  font-weight: bold;
`;
const Paragraph = styled.p`
  color: #7A7A7A;
  font-size: 16px;
`;
const MainParagraph = styled.p`
  padding: 1rem 0;
`;
const HighlightSection = styled.div`
  padding: 1.5rem;
  margin-top: 3rem;
  background: #F87B15;
  color: #fff;
  border-radius: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const HighlightTitle = styled.h3`
  color: #fff;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;
const HighlightText = styled.p`
  text-align: center;
  margin-bottom: 0.5rem;
  color: #fff;
`;
const HighlightButton = styled.a`
  background: #fff;
  color: #F87B15;
  border-radius: 9999px;
  padding: 0.5rem 1.5rem;
  font-weight: 600;
  margin-top: 1rem;
  text-decoration: none;
  display: inline-block;
`;

export default function About() {
  return (
    <Layout showCommonFooter={true}>
      <Container>
        <Title>About Us</Title>
        <MainParagraph>
          From home security cameras to wearable devices for activities like
          walking your dog, Sensforge products are designed to keep you
          connected and in the moment. With low-power chips and real-time
          updates, we ensure you never miss anything important. And by bringing
          manufacturing in-house, we can rapidly iterate to deliver the best
          possible experience.
        </MainParagraph>
        {/* Section 1 */}
        <SectionRow>
          <SectionCol style={{ order: 2 }}>
            <SectionImg src={About01} alt="About Us" />
          </SectionCol>
          <SectionCol style={{ order: 1 }}>
            <SubTitle>Our Mission</SubTitle>
            <Paragraph>
              Sensforge is dedicated to creating innovative, AI-driven security
              solutions that protect our loved ones while capturing life’s
              beautiful moments.
            </Paragraph>
          </SectionCol>
        </SectionRow>
        {/* Section 2 */}
        <SectionRow>
          <SectionCol style={{ order: 1 }}>
            <SubTitle>Our Journey</SubTitle>
            <Paragraph>
              It all started with a deer. Our founder was frustrated when a deer
              kept sneaking into his backyard and munching on his wife’s beloved
              vegetable garden. After setting up a camera to catch the culprit,
              he found that it didn’t provide enough information to solve the
              mystery. This lightbulb moment led to the creation of Sensforge,
              where our mission became clear: When Security Meets Fun. We wanted
              to develop smart, AI-powered cameras that not only keep you safe
              but also capture wonderful everyday moments.
            </Paragraph>
          </SectionCol>
          <SectionCol style={{ order: 2 }}>
            <SectionImg src={About02} alt="Our Journey" />
          </SectionCol>
        </SectionRow>
        {/* Section 3 */}
        <SectionRow>
          <SectionCol style={{ order: 2 }}>
            <SectionImg src={About03} alt="Community-Centric Approach" />
          </SectionCol>
          <SectionCol style={{ order: 1 }}>
            <SubTitle>Community-Centric Approach</SubTitle>
            <Paragraph>
              Our success is driven by a vibrant community of users who share
              our passion for accessible technology. We actively engage with our
              customers, valuing their feedback and incorporating their insights
              into our product development process. This collaborative spirit
              ensures that our offerings continually evolve to meet the
              real-world needs of our users.
            </Paragraph>
          </SectionCol>
        </SectionRow>
        {/* Section 4 */}
        <SectionRow>
          <SectionCol style={{ order: 1 }}>
            <SubTitle>Looking Ahead</SubTitle>
            <Paragraph>
              At Sensforge, we envision a future where technology seamlessly
              connects you to every moment. Our cameras are your eyes, capturing
              everything around you, while our software acts as your mind,
              processing and alerting you to what matters most. Looking ahead,
              we aim to create a world where you feel present for every
              important moment—whether you&apos;re securing your home, capturing
              memories, or staying informed in real time. As we continue to
              innovate, we’re committed to making everyday moments
              extraordinary, ensuring you’re always just a step away from what
              matters.
            </Paragraph>
          </SectionCol>
          <SectionCol style={{ order: 2 }}>
            <SectionImg src={About04} alt="Looking Ahead" />
          </SectionCol>
        </SectionRow>
        <HighlightSection>
          <HighlightTitle>Current Openings</HighlightTitle>
          <HighlightText>
            We&apos;re always on the lookout for talented individuals who are
            excited <br />
            about technology and innovation. Whether you&apos;re a seasoned <br />
            professional or just starting your career, <br />
            there&apos;s a place for you at SensForge.<br />
          </HighlightText>
          <HighlightText>
            Don’t see a role that fits? <br />
            We’d still love to hear from you! <br />
            Send us your resume at careers@sensforge.com.<br />
            Come build the future with us!<br />
          </HighlightText>
          <HighlightButton
            href="mailto:careers@sensforge.com"
            type="button"
          >
            View All Openings
          </HighlightButton>
        </HighlightSection>
      </Container>
    </Layout>
  );
}
